import PropTypes from 'prop-types'
import { Link as RouterLink } from 'react-router-dom'
import {
  Breadcrumbs,
  IconButton,
  Link,
  Typography
} from '@mui/material'
import Iconify from 'components/Iconify'

const _Breadcrumbs = ({ items, noback = false }) => (
  <Breadcrumbs aria-label="breadcrumb">
    {noback ? null : (
      <IconButton aria-label="back" onClick={() => history.back()}>
        <Iconify icon="pajamas:go-back" />
      </IconButton>
    )}

    {
      items.map((item, key) => (
        item.path ? (
          <Link
            key={key}
            underline="hover"
            color="inherit"
            to={item.path}
            component={RouterLink}
          >
            {item.label}
          </Link>
        ) : (
          <Typography
            key={key}
            color="text.primary"
          >
            {item.label}
          </Typography>
        )
      ))
    }
  </Breadcrumbs>
)

_Breadcrumbs.propTypes = {
  items: PropTypes.array
}

export default _Breadcrumbs
